<template>
	<div class="wrap">
		<div class="main">
			<div class="neibox">
				<el-table :data="caiWuList" style="width: 100%">
					<el-table-column prop="create_time" label="交易时间" width="180">
					</el-table-column>
					<el-table-column  prop="is_add" label="交易类型"  width="180">
						<template slot-scope="scope">
							<div class="koutxt" v-if="scope.row.is_add == 0">扣款</div>
							<div class="rutxt" v-else-if="scope.row.is_add == 1">入款</div>
							<div class="rutxt" v-else>虚增</div>
						</template>
					</el-table-column>
					<el-table-column prop="bank" label="交易渠道"  width="180">
					</el-table-column>

					<el-table-column prop="money" label="交易价格"  width="180">
					</el-table-column>
					<el-table-column prop="money2" label="可用余额"  width="180">
					</el-table-column>
					<el-table-column prop="forwhat" label="交易描述">
					</el-table-column>
				</el-table>
				<div class="fenye">
					<FenPage :total="page_data.total"  :page.sync="page_data.page" :limit.sync="page_data.limit" @pagination="getFinance" />
				</div>

			</div>

		</div>
	</div>
</template>

<script> 
	import FenPage from '../../components/FenPage.vue'
	export default {
		components:{
			FenPage
		},
		data() {
			return {
				// 表格
				caiWuList: [],
				// 分页
				page_data: {
					limit: 15,
					page: 1,
					total:20,
				},
			}
		},
		created() {
			this.getFinance()
		},
		methods: {
			// 请求列表
			async getFinance() {
				let param = {limit:this.page_data.limit,page:this.page_data.page}
				const res = await this.$api.getFinance(param);
				this.caiWuList = res.data.data
				this.page_data.total = res.data.total
			},
			update(e){
				console.log(e)
			},
			handleDelete(index, row) {
				console.log(index, row);
				this.dialogVisible = true
			},

			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
			},


		},

	}
</script>

<style>
	.neibox {
		padding: 20px;
		background-color: #ffffff;
		border-radius: 5px;
	}

	.shaibox {
		display: flex;
		align-items: center;
		padding-bottom: 25px;
	}

	.taibox {
		width: 60px;
		height: 20px;
		background-color: #FF8900;
		text-align: center;
		line-height: 20px;
		font-size: 12px;
		color: #ffffff;
	}
	.koutxt{
		background-color: #F56C6C;
		width: 40px;
		height: 20px;
		text-align: center;
		line-height: 20px;
		font-size: 12px;
		color: #ffffff;
	}
	.rutxt{
		background-color: #409EFF;
		width: 40px;
		height: 20px;
		text-align: center;
		line-height: 20px;
		font-size: 12px;
		color: #ffffff;
	}
	.fenye {
		display: flex;
		align-items: center;
		justify-content: center;
		padding-top: 20px;
	}

	.el-dialog__header {
		background-color: #f8f8f8 !important;
	}

	.el-dialog__body {
		background-color: #f2f2f2 !important;
	}

	.el-dialog__footer {
		background-color: #f2f2f2 !important;
	}

	.xubox {
		background-color: #ffffff;
		padding: 15px;
	}

	.xutitle {
		font-size: 22px;
		color: #333333;
		border-bottom: 1px solid #dddddd;
		padding-bottom: 10px;
		margin-bottom: 15px;
	}

	.biao {
		border: 1px solid #dddddd;
	}

	.biaotop {
		padding: 0 20px;
		background-color: #f1f1f1;
		border-bottom: 1px solid #dddddd;
		height: 50px;
		line-height: 50px;
		font-size: 14px;
		color: #333333;
	}

	.chantui {
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 50px;
		border-bottom: 1px solid #dddddd;
		height: 50px;
	}

	.chanli {
		height: 50px;
		line-height: 50px;
		width: 50%;
		border-right: 1px solid #dddddd;
	}

	.chanli:last-child {
		border: none;
	}

	.chantxt {
		padding: 0 20px;
		font-size: 14px;
		color: #333333;
	}

	.kaibox {
		display: flex;
		align-items: center;
		height: 50px;
		padding: 0 20px;
	}

	.kaili {
		font-size: 14px;
		color: #333333;
		padding-right: 100px;
	}

	.kaili span {
		color: #ff0000;
		font-size: 14px;
	}

	.zebox {
		padding: 20px 20px 0;
	}

	.zetxt {
		font-size: 14px;
		color: #333333;
		padding-right: 10px;
	}

	.zeli {
		display: flex;
		align-items: center;
		padding-bottom: 10px;
	}

	.el-dialog__footer {
		text-align: left;
	}
</style>